import React, { Component } from 'react';
import { SimpleSelect } from 'react-selectize-advizr';
import { DragDropContext } from 'react-dnd';
import PropTypes from 'prop-types';
import HTML5Backend from 'react-dnd-html5-backend';
import SortList from '../CommonComponents/SortList';
import AdvForm from '../CommonComponents/AdvForm';
// eslint-disable-next-line @typescript-eslint/camelcase
import { find_ancestor } from '../../js/app/react/helpers.objects';
import SaveModal from './Popups/SaveModal';
import ErrorBubble from '../CommonComponents/ErrorBubble';
import EditPDFSectionModal from './Popups/EditPDFSectionModal';
import CustomDragLayer from '../CommonComponents/CustomDragLayer';
import { Tooltip } from '../CommonComponents/OPL/Tooltip/Tooltip';
import { PRINT_MAX_COLS_PER_PAGE } from '../AdvancedReports/AdvancedReportsHelpers';
import {
  hasPopup,
  hasExpando,
  itemTitleInSortList,
  itemFromOptionLabel,
  getInsertPageOptionList,
  getPreventDropOn,
  hasDelete,
} from './PDFHelpers';
import { AdvDropdown, DropdownAlignments } from '../CommonComponents/AdvDropdown';
import { Alert } from '../CommonComponents/Alert/Alert';
import ADVSelect from '../CommonComponents/Select';
import { InsuranceFieldsInputContainer, InsuranceFieldsLabel } from './PDFViewStyles';
import { StyledError } from '../CommonComponents/FormikError';
import { ComparePlans } from './components/ComparePlans/ComparePlans';
import { BeFi20 } from './components/BeFi20/BeFi20';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { SingleDatePicker } from '../CommonComponents/OPL/dates/SingleDatePicker/SingleDatePicker';
import { dateToISO8601 } from '../AccountPerformanceReporting/helpers/dates';
import { AssetBucketing } from './components/AssetBucketing/AssetBucketing';
import { ReportPreview } from './components/ReportPreview/ReportPreview';
import { Button } from '../CommonComponents/OPL/Button/Button';
import { Select } from '../CommonComponents/OPL/Select/Select/Select';
import { queryClient } from '../../config/queryClient';
import { queryKeys } from '../DocumentVault/api/queryKeys';

let spinner;

class PDFView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      included: [],
      excluded: [],
      show_save_template: false,
      editing_item: null,
      editComparePlansData: null,
      editBeFi20Data: null,
      assetBucketingData: null,
      isModalOpen: false,
    };

    this.updateSectionTitleFields = this.updateSectionTitleFields.bind(this);
    this.updateEditFormFields = this.updateEditFormFields.bind(this);
    this.updateReportFields = this.updateReportFields.bind(this);
    this.updateCoverPageFields = this.updateCoverPageFields.bind(this);
    this.updateLifeInsuranceFields = this.updateLifeInsuranceFields.bind(this);
    this.handleRecommendationsChange = this.handleRecommendationsChange.bind(this);
    this.setEditComparePlansData = this.setEditComparePlansData.bind(this);
    this.setEditBeFi20Data = this.setEditBeFi20Data.bind(this);
    this.setAssetBucketingData = this.setAssetBucketingData.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      included: nextProps.sections.included,
      excluded: nextProps.sections.excluded,
    });
  }

  componentDidMount() {
    const { portalName, fetch_data, clientId } = this.props;

    fetch_data(clientId);

    document.title = `Download PDF | ${portalName}`;
  }

  componentWillUnmount() {
    const { clearDownloadErrors } = this.props;

    clearDownloadErrors();
  }

  handleTemplateChange(template_name) {
    const { getTemplate, clientId } = this.props;

    getTemplate(template_name.label, clientId, template_name.isFirmLevelTemplate);
  }

  openSaveTemplate() {
    this.setState({
      show_save_template: true,
    });
  }

  deleteTemplate(name, self, isFirmLevelTemplate) {
    const { deleteTemplate, clientId } = self.props;

    deleteTemplate(name, clientId, isFirmLevelTemplate);
  }

  deleteSection(index, list, self) {
    const { deleteSection, clientId } = self.props;

    deleteSection(index, list, clientId);
  }

  saveTemplate(name, isFirmLevelTemplate) {
    const { sections, clientId, saveTemplate } = this.props;

    saveTemplate(sections, name, clientId, isFirmLevelTemplate);

    this.setState(
      {
        save_message: 'Template successfully saved!',
      },
      () => {
        setTimeout(() => {
          this.setState({
            save_message: '',
          });
        }, 2500);
      },
    );
    this.setSaveClosed();
  }

  downloadPdf() {
    const { download_pdf, clientId, fpId, sections } = this.props;

    download_pdf(sections, clientId, fpId);
  }

  updateSectionTitleFields(item, isEdit, list) {
    const { addItemIncluded } = this.props;

    const currentTitle = this.state.editing_item
      ? this.state.editing_item.editableFields
        ? this.state.editing_item.editableFields.title
        : item.editableFields.title
      : item.editableFields.title;
    const currentBody = this.state.editing_item
      ? this.state.editing_item.editableFields
        ? this.state.editing_item.editableFields.body
        : item.editableFields.body
      : item.editableFields.body;

    this.setState({
      editing_item: {
        reactFields: [
          <li>
            <label>Title</label>
            <div className="input">
              <input
                type="text"
                onChange={e => {
                  this.changeEditingItem(e);
                  this.updateSectionTitleFields(item, isEdit, list);
                }}
                value={currentTitle}
                className="md"
                name="title"
              />
            </div>
          </li>,
          <li>
            <label>Body</label>
            <textarea
              name="body"
              className="md"
              value={currentBody}
              onChange={e => {
                this.changeEditingItem({
                  target: {
                    value: e.target.value,
                    name: 'body',
                  },
                });
                this.updateSectionTitleFields(item, isEdit, list);
              }}
            />
          </li>,
        ],
        save: () => {
          const { editing_item } = this.state;
          if (!isEdit) {
            addItemIncluded({
              title: `Section Title #${ADV.util.randomString(10)}`,
              type: 'SectionTitle',
              editableFields: {
                title: editing_item.editableFields.title,
                body: editing_item.editableFields.body,
              },
              nonExcludable: false,
              hidden: false,
            });
          } else {
            this.handleFormChange(
              {
                target: {
                  name: 'title',
                  value: editing_item.editableFields.title,
                },
              },
              item,
              list,
            );
            this.handleFormChange(
              {
                target: {
                  name: 'body',
                  value: editing_item.editableFields.body,
                },
              },
              item,
              list,
            );
          }
          this.setAddClosed();
        },
        title: isEdit ? 'Edit Section' : 'Add Section',
        type: 'SectionTitle',
        editableFields: {
          title: currentTitle,
          body: currentBody,
        },
        nonExcludable: false,
        hidden: false,
      },
    });
  }

  updateReportFields(item, isEdit, list) {
    const { addItemIncluded, set_warnings, clientId } = this.props;

    const reports = item
      ? item.editableFields.reports
      : {
          defaultReports: [],
          savedReports: [],
        };

    const currentSelectedReport = this.state.editing_item
      ? this.state.editing_item.editableFields
        ? this.state.editing_item.editableFields.selectedReport
        : item.editableFields.selectedReport
      : item.editableFields.selectedReport;

    const selectOptions = reports.defaultReports
      .map(defaultReport => ({
        label: defaultReport.name,
        value: defaultReport.name,
        cols: defaultReport.cols,
      }))
      .concat(
        reports.firmLevelReports.map(savedReport => ({
          label: savedReport.name,
          value: savedReport.name,
          cols: savedReport.cols,
        })),
      )
      .concat(
        reports.savedReports.map(savedReport => ({
          label: savedReport.name,
          value: savedReport.name,
          cols: savedReport.cols,
        })),
      );

    const selectedReport = selectOptions.find(option => option.value === currentSelectedReport);
    if (selectedReport && selectedReport.cols > PRINT_MAX_COLS_PER_PAGE) {
      set_warnings(
        [
          `The selected report has more than ${PRINT_MAX_COLS_PER_PAGE} columns. Some columns will be trimmed.`,
        ],
        clientId,
      );
    } else {
      set_warnings([], clientId);
    }

    this.setState({
      editing_item: {
        reactFields: [
          <li>
            <label>Template</label>
            <SimpleSelect
              className="md"
              options={selectOptions}
              onValueChange={value => {
                this.changeEditingItem({
                  target: {
                    value: value.value,
                    name: 'selectedReport',
                  },
                });
                this.updateReportFields(item, isEdit, list);
              }}
              value={{
                label: currentSelectedReport,
                value: currentSelectedReport,
              }}
            />
          </li>,
        ],
        save: () => {
          const { editing_item } = this.state;
          if (!isEdit) {
            addItemIncluded({
              title: `Report #${ADV.util.randomString(10)}`,
              type: 'AdvancedReport',
              editableFields: {
                selectedReport: editing_item.editableFields.selectedReport,
              },
              nonExcludable: false,
              hidden: false,
            });
          } else {
            this.handleFormChange(
              {
                target: {
                  name: 'selectedReport',
                  value: editing_item.editableFields.selectedReport,
                },
              },
              item,
              list,
            );
          }
          this.setAddClosed();
        },
        title: isEdit ? 'Edit Report' : 'Add Report',
        type: 'AdvancedReport',
        editableFields: {
          selectedReport: currentSelectedReport,
        },
        nonExcludable: false,
        hidden: false,
      },
    });
  }

  updateCoverPageFields(item, list) {
    const getCurrentField = fieldName => {
      return this.state.editing_item
        ? this.state.editing_item.editableFields
          ? this.state.editing_item.editableFields[fieldName]
          : item.editableFields[fieldName]
        : item.editableFields[fieldName];
    };

    const currentTitle = getCurrentField('title');
    const currentDate = getCurrentField('date');
    const currentSignature = getCurrentField('signature');

    this.setState({
      editing_item: {
        reactFields: [
          <li>
            <label>Title</label>
            <div className="input">
              <input
                type="text"
                className="md"
                name="title"
                value={currentTitle}
                onChange={e => {
                  this.changeEditingItem({
                    target: {
                      value: e.target.value,
                      name: 'title',
                    },
                  });
                  this.updateCoverPageFields(item, list);
                }}
              />
            </div>
          </li>,
          <li>
            <label>Signature</label>
            <textarea
              name="signature"
              className="md"
              maxLength={2500}
              value={currentSignature}
              onChange={e => {
                this.changeEditingItem({
                  target: {
                    value: e.target.value,
                    name: 'signature',
                  },
                });
                this.updateCoverPageFields(item, list);
              }}
            />
          </li>,
          <li>
            <label>Date</label>

            <SingleDatePicker
              date={new Date(currentDate) ?? undefined}
              onChange={value => {
                this.changeEditingDate(dateToISO8601(value));
                this.updateCoverPageFields(item, list);
              }}
              minDate={new Date(1900, 0)}
            />
          </li>,
        ],
        save: () => {
          const { editing_item } = this.state;
          this.handleFormChange(
            {
              target: {
                name: 'signature',
                value: editing_item.editableFields.signature,
              },
            },
            item,
            list,
          );
          this.handleDateChange(editing_item.editableFields.date, item, list);
          this.handleFormChange(
            {
              target: {
                name: 'title',
                value: editing_item.editableFields.title,
              },
            },
            item,
            list,
          );
          this.setAddClosed();
        },
        title: 'Edit Cover Page',
        type: 'CoverPage',
        editableFields: {
          date: currentDate,
          signature: currentSignature,
          title: currentTitle,
        },
        nonExcludable: false,
        hidden: false,
      },
    });
  }

  updateLifeInsuranceFields(item, list) {
    const getCurrentField = fieldName => {
      return this.state.editing_item
        ? this.state.editing_item.editableFields
          ? this.state.editing_item.editableFields[fieldName]
          : item.editableFields[fieldName]
        : item.editableFields[fieldName];
    };
    const currentOwners = getCurrentField('owners');
    const currentRecommendations = getCurrentField('recommendations');
    const currentSelectedOwners = getCurrentField('selectedOwners');
    const currentSelectedRecommendations = getCurrentField('selectedRecommendations');

    this.setState({
      editing_item: {
        reactFields: [
          <InsuranceFieldsInputContainer>
            <InsuranceFieldsLabel>Owner</InsuranceFieldsLabel>
            <ADVSelect
              value={{
                label: currentOwners.find(x => x.id === currentSelectedOwners).name,
                value: currentSelectedOwners,
              }}
              options={currentOwners.map(owner => ({
                label: owner.name,
                value: owner.id,
              }))}
              onChange={value => {
                this.changeEditingItem({
                  target: {
                    value: value.value,
                    name: 'selectedOwners',
                  },
                });
                this.updateLifeInsuranceFields(item, list);
              }}
            />
          </InsuranceFieldsInputContainer>,
          <InsuranceFieldsInputContainer>
            <InsuranceFieldsLabel>Recommendation</InsuranceFieldsLabel>
            <ADVSelect
              closeMenuOnSelect={false}
              menuPlacement="auto"
              isMulti
              isClearable={false}
              options={currentRecommendations.map(rec => ({
                label: rec,
                value: rec,
              }))}
              value={currentSelectedRecommendations.map(rec => ({
                label: rec,
                value: rec,
              }))}
              onChange={values => {
                this.changeEditingRecommendations(values.map(x => x.value));
                this.updateLifeInsuranceFields(item, list);
              }}
              noOptionsMessage={() => <span>There are no recommendations left to add</span>}
            />
            {currentSelectedRecommendations.length === 0 && (
              <StyledError>Select at least one recommendation</StyledError>
            )}
          </InsuranceFieldsInputContainer>,
        ],
        save: () => {
          const { editing_item } = this.state;

          const {
            editableFields: { selectedRecommendations, selectedOwners },
          } = editing_item;

          if (Array.isArray(selectedRecommendations) && selectedRecommendations.length === 0) {
            return;
          }

          this.handleFormChange(
            {
              target: {
                name: 'selectedOwners',
                value: selectedOwners,
              },
            },
            item,
            list,
          );
          this.handleFormChange(
            {
              target: {
                name: 'selectedRecommendations',
                value: selectedRecommendations,
              },
            },
            item,
            list,
          );
          this.setAddClosed();
        },
        title: 'Life Insurance',
        type: 'LifeInsurance',
        editableFields: {
          owners: currentOwners,
          recommendations: currentRecommendations,
          selectedOwners: currentSelectedOwners,
          selectedRecommendations: currentSelectedRecommendations,
        },
        nonExcludable: false,
        hidden: false,
      },
    });
  }

  setSaveClosed() {
    this.setState({
      show_save_template: false,
    });
  }

  setAddClosed() {
    this.props.set_warnings(null, this.props.clientId);
    this.setState({
      editing_item: null,
    });
  }

  handleFormChange(e, item, list) {
    const { changeModifiableItem, clientId } = this.props;
    const { name } = e.target;
    const modifiable_item = Object.assign({}, item);

    modifiable_item.editableFields[name] =
      e.target.value != null ? e.target.value : e.target.innerHTML;

    changeModifiableItem(modifiable_item, list, clientId);
  }

  handleDateChange(value, item, list) {
    this.handleFormChange(
      {
        target: {
          name: 'date',
          value,
        },
      },
      item,
      list,
    );
  }

  handleRecommendationsChange(recommendations, item, list) {
    this.handleFormChange(
      {
        target: {
          name: 'selectedRecommendations',
          value: recommendations,
        },
      },
      item,
      list,
    );
  }

  changeEditingItem(e) {
    const { editing_item } = this.state;
    const local_item = { ...editing_item };

    local_item.editableFields[e.target.name] = e.target.value;

    this.setState({
      editing_item: local_item,
    });
  }

  changeEditingDate(value) {
    const { editing_item } = this.state;
    const local_item = { ...editing_item };

    local_item.editableFields.date = value;

    this.setState({
      editing_item: local_item,
    });
  }

  changeEditingRecommendations(values) {
    const { editing_item } = this.state;
    const local_item = { ...editing_item };

    local_item.editableFields.selectedRecommendations = values;

    this.setState({
      editing_item: local_item,
    });
  }

  setEditComparePlansData(data) {
    this.setState({ editComparePlansData: data });
  }

  setEditBeFi20Data(data) {
    this.setState({ editBeFi20Data: data });
  }

  setAssetBucketingData(data) {
    this.setState({ assetBucketingData: data });
  }

  buildRow(item, list, ndx, self) {
    const retElements = [];

    retElements.push(
      <div
        onClick={e => {
          const target = find_ancestor(e.target, 'li');
          if (target.classList.contains('expanded')) {
            target.classList.remove('expanded');
          } else {
            target.classList.add('expanded');
          }
        }}
      >
        {hasExpando(item) && <i className="fa fa-caret-right" />}
        <span
          className={`title${hasPopup(item) ? ' bold' : ''}`}
          style={{
            display: 'block',
            maxWidth: '80%',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {itemTitleInSortList(item)}
        </span>
        <span className="actions">
          <>
            {hasPopup(item) ? (
              <a onClick={() => self.updateEditFormFields(item, true, list)}>
                <i className="far fa-edit" />
              </a>
            ) : null}
            {!item.nonExcludable && (
              <a
                onClick={() => {
                  if (hasDelete(item)) {
                    self.props.deleteSection(ndx, list, self.props.clientId);
                  } else {
                    self.props[`removeItem${list === 'included' ? 'Included' : 'Excluded'}`](ndx);
                    self.props[`addItem${list === 'included' ? 'Excluded' : 'Included'}`](item);
                  }
                }}
              >
                <i
                  className={`fa ${
                    hasDelete(item)
                      ? 'fa-trash-alt'
                      : list === 'included'
                      ? 'fa-minus-circle'
                      : 'fa-plus-circle'
                  }`}
                />
              </a>
            )}
          </>
          <a>
            <i className="fa fa-arrows-alt drag-handle" />
          </a>
        </span>
      </div>,
    );
    if (hasExpando(item)) {
      retElements.push(
        <section
          className="expando"
          onMouseOver={() =>
            self.setState({
              over_expando: true,
            })
          }
          onMouseLeave={() =>
            self.setState({
              over_expando: false,
            })
          }
        >
          <AdvForm onChange={e => this.handleFormChange(e, item, list)}>
            <ul className="vertical-layout">
              <li>
                <label>Title</label>
                <div className="input">
                  <input
                    type="text"
                    className="md"
                    name="title"
                    value={item.editableFields.title}
                  />
                </div>
              </li>
            </ul>
            <div className="buttons">
              <button onClick={() => this.deleteSection(ndx, list, self)} className="red">
                Delete Section
              </button>
            </div>
          </AdvForm>
        </section>,
      );
    }
    return {
      id: `${list}_${ndx}`,
      listClassName: 'advanced-pdf-sort-list-ul',
      className: 'advanced-pdf-sort-list-li',
      item: retElements,
      originalIndex: ndx,
      sourceListItem: item,
      hidden: item.hidden,
      preventDropOn: getPreventDropOn(item),
    };
  }

  updateEditFormFields(item, isEdit, list) {
    // Add fields from the hidden sections to the saved sections
    const { included, excluded } = this.state;
    const all = included.concat(excluded).filter(item => item.hidden);
    const target = all.filter(itm => itm.hidden).find(itm => item.type === itm.type);
    item = {
      ...item,
      editableFields: {
        ...(target ? target.editableFields : {}),
        ...item.editableFields,
      },
    };
    switch (item.type) {
      case 'SectionTitle':
        this.updateSectionTitleFields(item, isEdit, list);
        break;
      case 'AdvancedReport':
        this.updateReportFields(item, isEdit, list);
        break;
      case 'CoverPage':
        this.updateCoverPageFields(item, list);
        break;
      case 'LifeInsurance':
        this.updateLifeInsuranceFields(item, list);
        break;
      case 'ComparePlans':
        this.setEditComparePlansData({ item, list });
        break;
      case 'BeFi20':
        this.setEditBeFi20Data({ item, list });
        break;
      case 'ProtectLiveDream':
        this.setAssetBucketingData({ item, list });
    }
  }

  render() {
    const {
      template_names,
      removeItemIncluded,
      addItemIncluded,
      moveItemIncluded,
      removeItemExcluded,
      addItemExcluded,
      moveItemExcluded,
      name,
      isFirmLevelTemplate,
      downloading,
      enabled,
      canSaveTemplate,
      canDeleteTemplate,
      downloadErrors,
      hasFirmSettingsAccess,
      sections,
      hasEnhancedReportExperience,
      savedReportsPath,
      clientId,
    } = this.props;

    const {
      included,
      excluded,
      show_save_template,
      save_message,
      editing_item,
      over_expando,
      editComparePlansData,
      editBeFi20Data,
      assetBucketingData,
      isModalOpen,
    } = this.state;

    // Kills me, but we have to do spinners in render in order for them to work
    if (downloading) {
      spinner = new ADV.util.Spinner();
    } else if (spinner) {
      spinner.destroy();
    }

    const templateOptions = [
      { label: '', options: [{ label: 'Default Template', value: 0 }] },
      {
        label: 'Firm-Level Templates',
        options: (template_names || []).filter(template => template.isFirmLevelTemplate),
      },
      {
        label: 'Saved Templates',
        options: (template_names || []).filter(
          template => !template.isFirmLevelTemplate && template.value !== 0,
        ),
      },
    ];

    return !!included.length || !!excluded.length ? (
      <>
        {isModalOpen && (
          <ReportPreview
            sections={sections}
            onClose={() => {
              this.setState({ isModalOpen: false });
            }}
          />
        )}

        <div className="PDF" id="Advanced_PDF">
          <header>
            <h2>Generate PDF</h2>
            <h3>
              Drag and drop sections to re-order them or exclude them from the PDF, then click
              {hasEnhancedReportExperience
                ? 'Generate Report to create your custom document'
                : 'Download PDF to generate the report.'}
            </h3>
          </header>
          <ErrorBubble InfoMessage={[save_message]} show={!!save_message} />

          {downloadErrors && downloadErrors.length > 0 && <Alert message={downloadErrors} />}

          <Box as="section" display="flex" alignItems="center" justifyContent="space-between">
            <Box display="flex" alignItems="center" css="gap: 4px">
              <Box style={{ width: '230px' }}>
                <Select
                  value={
                    name ? { label: name, value: name } : { label: 'Default Template', value: 0 }
                  }
                  options={templateOptions}
                  onChange={this.handleTemplateChange.bind(this)}
                />
              </Box>
              {canSaveTemplate ? (
                <Box display="flex" alignItems="center" css="gap: 4px">
                  {name && (!isFirmLevelTemplate || hasFirmSettingsAccess) && (
                    <Button
                      variant="secondary"
                      onClick={() => this.saveTemplate(name, isFirmLevelTemplate)}
                    >
                      Update Template
                    </Button>
                  )}
                  <Button variant="secondary" onClick={() => this.openSaveTemplate()}>
                    Save Template
                  </Button>
                </Box>
              ) : null}
            </Box>

            <Box display="flex" alignItems="center" css="gap: 4px">
              {canDeleteTemplate && (!isFirmLevelTemplate || hasFirmSettingsAccess) && name && (
                <Button
                  variant="error"
                  disabled={!name}
                  onClick={() => this.deleteTemplate(name, this, isFirmLevelTemplate)}
                >
                  Delete Template
                </Button>
              )}
              {!enabled && (
                <Tooltip content="No plan has been generated for this client. Generate a plan using the wizard or by populating the client profile and this option will be enabled.">
                  <Button rightIcon="far fa-question-circle">Download PDF</Button>
                </Tooltip>
              )}
              {enabled && !hasEnhancedReportExperience && (
                <Button
                  onClick={this.downloadPdf.bind(this)}
                  disabled={downloading}
                  isLoading={downloading}
                >
                  Download PDF
                </Button>
              )}

              {enabled && hasEnhancedReportExperience && (
                <>
                  {savedReportsPath && (
                    <Button
                      variant="secondary"
                      onClick={() => {
                        const path = encodeURIComponent(savedReportsPath);
                        const providerTypeAll = 1;

                        queryClient.invalidateQueries(
                          queryKeys.listDocumentVaultEntities(clientId, path, providerTypeAll),
                        );

                        ADV.util.Router.go2('DocumentVault', {
                          clientId,
                          path,
                          providerType: providerTypeAll,
                          previousComponent: 'AdvancedPDF',
                        });
                      }}
                      disabled={downloading}
                      isLoading={downloading}
                    >
                      View Past Reports
                    </Button>
                  )}

                  <Button
                    onClick={() => {
                      this.setState({ isModalOpen: true });
                    }}
                    disabled={downloading}
                    isLoading={downloading}
                  >
                    Generate Report
                  </Button>
                </>
              )}
            </Box>
          </Box>

          <section className="sort-lists">
            <CustomDragLayer />
            <SortList
              id="included"
              className="included table-like with-actions with-expansion advanced-pdf-sort-list-ul"
              list={included.map((item, i) => this.buildRow(item, 'included', i, this))}
              addItem={addItemIncluded}
              removeItem={removeItemIncluded}
              moveItem={moveItemIncluded}
              preventDrag={over_expando}
            >
              <li className="header">
                Included in PDF
                <AdvDropdown
                  dropdownAlignment={DropdownAlignments.RIGHT}
                  placeholder="Insert Page"
                  className="sm"
                  options={getInsertPageOptionList(included.concat(excluded))}
                  onOptionSelect={option =>
                    this.updateEditFormFields(
                      itemFromOptionLabel(option, included.concat(excluded)),
                      false,
                    )
                  }
                />
              </li>
            </SortList>
            <SortList
              id="excluded"
              className="excluded table-like with-actions with-expansion advanced-pdf-sort-list-ul"
              list={excluded.map((item, i) => this.buildRow(item, 'excluded', i, this))}
              addItem={addItemExcluded}
              removeItem={removeItemExcluded}
              moveItem={moveItemExcluded}
              preventDrag={over_expando}
            >
              <li className="header">Excluded from PDF</li>
            </SortList>
          </section>
          {!!show_save_template && (
            <SaveModal
              modal_open
              template_names={template_names}
              on_cancel={() => this.setSaveClosed(this)}
              on_save={_isFirmLevelTemplate => {
                const name = document.querySelector('#template_name');
                this.saveTemplate(name.value, _isFirmLevelTemplate);
              }}
            />
          )}
          {!!editing_item && (
            <EditPDFSectionModal
              modal_open
              title={editing_item.title}
              reactFields={editing_item.reactFields}
              on_save={editing_item.save}
              on_cancel={() => this.setAddClosed()}
              warnings={this.props.warnings}
              on_hide_warnings={() => this.props.set_warnings(null, this.props.clientId)}
            />
          )}

          {editComparePlansData && (
            <ComparePlans
              data={editComparePlansData.item.editableFields}
              onSave={selectedPlans => {
                this.handleFormChange(
                  {
                    target: {
                      name: 'selectedPlans',
                      value: selectedPlans,
                    },
                  },
                  editComparePlansData.item,
                  editComparePlansData.list,
                );
              }}
              onClose={() => this.setEditComparePlansData(null)}
            />
          )}

          {editBeFi20Data && (
            <BeFi20
              data={editBeFi20Data.item.editableFields}
              onSave={selectedComparisons => {
                this.handleFormChange(
                  {
                    target: {
                      name: 'selectedComparisons',
                      value: selectedComparisons,
                    },
                  },
                  editBeFi20Data.item,
                  editBeFi20Data.list,
                );
              }}
              onClose={() => this.setEditBeFi20Data(null)}
            />
          )}

          {assetBucketingData && (
            <AssetBucketing
              data={assetBucketingData.item.editableFields}
              onSave={showFullBreakdown => {
                this.handleFormChange(
                  {
                    target: {
                      name: 'showFullBreakdown',
                      value: showFullBreakdown,
                    },
                  },
                  assetBucketingData.item,
                  assetBucketingData.list,
                );
              }}
              onClose={() => this.setAssetBucketingData(null)}
            />
          )}
        </div>
      </>
    ) : null;
  }
}

PDFView.defaultProps = {
  savedReportsPath: null,
};

PDFView.propTypes = {
  portalName: PropTypes.string.isRequired,
  isFirmLevelTemplate: PropTypes.bool.isRequired,
  savedReportsPath: PropTypes.string,
};

PDFView.expanded_rows = { included: [], excluded: [] };

export default DragDropContext(HTML5Backend)(PDFView);
